<template>
  <ReviewsCategoriesTableContainer
    v-bind="tableContainerAttrs"
    v-on="tableContainerEvents"
  >
    <template v-slot:customColumn="{ item, columnName }">
      <ReviewsCategoriesColorScaleTableColumn
        :value="item[columnName]"
        :item="item"
        :colors="colors"
        :column-name="columnName"
        :is-comparison-enabled="isComparing"
      />
    </template>
  </ReviewsCategoriesTableContainer>
</template>

<script>
import ReviewsCategoriesColorScaleTableColumn from "./ReviewsCategoriesColorScaleTableColumn.vue";
import ReviewsCategoriesTableContainer from "./ReviewsCategoriesTableContainer.vue";
import { categoryTableWrapper } from "@/helpers/mixins/category-table-wrapper.js";
import { sentimentAggregatedHeaders } from "@/config/categories-table-columns";
import TinyGradient from "tinygradient";

export default {
  name: "ReviewsCategoriesAverageTable",
  mixins: [categoryTableWrapper],
  components: {
    ReviewsCategoriesColorScaleTableColumn,
    ReviewsCategoriesTableContainer
  },
  data() {
    return {
      sentimentAggregatedHeaders: sentimentAggregatedHeaders(),
      colors: [],
      formattedGridData: {
        results: [],
        count: 0
      }
    };
  },
  computed: {
    headers() {
      const { comparison } = this.gridData;

      if (comparison.results.length) {
        return this.sentimentAggregatedHeaders;
      }

      return this.sentimentAggregatedHeaders.filter(
        item => item.value !== "selected_period_sentiment"
      );
    }
  },
  created() {
    const gradient = TinyGradient([
      { color: "#D4F3DE", pos: 0 },
      { color: "#F3F7D4", pos: 0.48 },
      { color: "#F8F8D2", pos: 0.49 },
      { color: "#F8F8D2", pos: 0.51 },
      { color: "#FAEFD7", pos: 0.52 },
      { color: "#FFD6E2", pos: 1 }
    ]);
    const colorsRgb = gradient.rgb(201).reverse();
    colorsRgb.forEach(e => {
      this.colors.push(e.toHexString());
    });
  },
  methods: {
    getFormattedGridData() {
      const { comparison, basic } = this.gridData;

      if (!comparison.results.length) {
        return basic;
      }
      const results = basic.results.map((item, index) => ({
        ...item,
        selected_period_sentiment: comparison.results[index].period_sentiment
      }));

      return {
        results,
        count: basic.count
      };
    }
  },
  watch: {
    basicFilters: {
      async handler() {
        await this.getGridData();
      },
      deep: true
    }
  }
};
</script>
